// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1MctB","footer":"Form_footer__21XKR"};